var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.95 25.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#ffab02;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 25.95,
    height: 25.95,
    rx: 5.38,
    ry: 5.38
  }), /*#__PURE__*/React.createElement("path", {
    id: "whatsapp",
    className: "cls-1",
    d: "m13.43,19.37c-1.16,0-2.31-.29-3.33-.86l-4.44,1.77,1.77-4.44c-.57-1.02-.86-2.16-.86-3.33,0-.92.18-1.82.54-2.66.69-1.65,2-2.96,3.65-3.65,1.7-.72,3.63-.72,5.33,0,1.65.69,2.96,2,3.65,3.65.72,1.7.72,3.63,0,5.33-.69,1.65-2,2.96-3.65,3.65-.84.36-1.75.55-2.66.54Zm2.29-5.48h-.91l-.51.46c-.61-.23-1.15-.61-1.58-1.11-.49-.43-.87-.97-1.11-1.58l.46-.51v-.91c0-.18-.06-.35-.17-.49-.1-.15-.23-.27-.38-.35-.14-.07-.24-.08-.29-.02l-.67.67c-.37.37-.43.95-.16,1.74.32.87.83,1.65,1.5,2.29.63.67,1.42,1.18,2.29,1.5.79.26,1.36.21,1.74-.16l.67-.67c.06-.06.05-.15-.02-.29-.08-.15-.2-.28-.35-.38-.14-.11-.31-.17-.49-.17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact3);
export default __webpack_public_path__ + "static/media/contact3.073bc20c06f803fa58d04c66b3214247.svg";
export { ForwardRef as ReactComponent };